// Version : 0.0.1
// Author : VISHNU
// LastEdit : SHIYAM
// MODFIED DATE : 31-07-2025

import EconomicActivityTypeActionTypes from './economic-activity-type.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	addEconomicActivityTypeDetailsResponse: null,
	updateEconomicActivityTypeDetailsResponse: null,

	getEconomicActivityTypeListResponse: null,
	getEconomicActivityTypeListArr: [],

	fetchEconomicActivityTypeDetailsResponse: null,
	fetchEconomicActivityTypeDetailsArr: [],

	deleteEconomicActivityTypeDetailsResponse: null,

	fetchAllEconomicActivityTypesResponse: null,
	fetchAllEconomicActivityTypesArr: [],
};

const economicActivityTypeReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD ECONOMIC ACTIVITY TYPE START *********************** */
		case EconomicActivityTypeActionTypes.ADD_ECONOMIC_ACTIVITY_TYPE_DETAILS_SUCCESS:
			return { ...state, addEconomicActivityTypeDetailsResponse: action.payload };

		case EconomicActivityTypeActionTypes.ADD_ECONOMIC_ACTIVITY_TYPE_DETAILS_FAILURE:
			return { ...state, addEconomicActivityTypeDetailsResponse: action.payload };

		case EconomicActivityTypeActionTypes.ADD_ECONOMIC_ACTIVITY_TYPE_DETAILS_RESPONSE_CHANGED:
			return { ...state, addEconomicActivityTypeDetailsResponse: null };
		/** ***************** ADD ECONOMIC ACTIVITY TYPE END *********************** */

		/** ***************** UPDATE ECONOMIC ACTIVITY TYPE START *********************** */
		case EconomicActivityTypeActionTypes.UPDATE_ECONOMIC_ACTIVITY_TYPE_DETAILS_SUCCESS:
			return { ...state, updateEconomicActivityTypeDetailsResponse: action.payload };

		case EconomicActivityTypeActionTypes.UPDATE_ECONOMIC_ACTIVITY_TYPE_DETAILS_FAILURE:
			return { ...state, updateEconomicActivityTypeDetailsResponse: action.payload };

		case EconomicActivityTypeActionTypes.UPDATE_ECONOMIC_ACTIVITY_TYPE_DETAILS_RESPONSE_CHANGED:
			return { ...state, updateEconomicActivityTypeDetailsResponse: null };
		/** ***************** UPDATE ECONOMIC ACTIVITY TYPE END *********************** */

		/** ***************** GET ECONOMIC ACTIVITY TYPE LIST START *********************** */
		case EconomicActivityTypeActionTypes.GET_ECONOMIC_ACTIVITY_TYPE_LIST_SUCCESS:
			return {
				...state,
				getEconomicActivityTypeListResponse: action.payload,
				getEconomicActivityTypeListArr: docodeHexResponse(
					action.payload,
					'GetEconomicActivityTypeListKey',
				),
			};

		case EconomicActivityTypeActionTypes.GET_ECONOMIC_ACTIVITY_TYPE_LIST_FAILURE:
			return { ...state, getEconomicActivityTypeListResponse: action.payload };

		case EconomicActivityTypeActionTypes.GET_ECONOMIC_ACTIVITY_TYPE_LIST_RESPONSE_CHANGED:
			return { ...state, getEconomicActivityTypeListResponse: null };
		/** ***************** GET ECONOMIC ACTIVITY TYPE LIST END *********************** */

		/** ***************** FETCH ECONOMIC ACTIVITY TYPE DETAILS START *********************** */
		case EconomicActivityTypeActionTypes.FETCH_ECONOMIC_ACTIVITY_TYPE_DETAILS_SUCCESS:
			return {
				...state,
				fetchEconomicActivityTypeDetailsResponse: action.payload,
				fetchEconomicActivityTypeDetailsArr: docodeHexResponse(
					action.payload,
					'FetchEconomicActivityTypeDetailsKey',
				),
			};

		case EconomicActivityTypeActionTypes.FETCH_ECONOMIC_ACTIVITY_TYPE_DETAILS_FAILURE:
			return { ...state, fetchEconomicActivityTypeDetailsResponse: action.payload };

		case EconomicActivityTypeActionTypes.FETCH_ECONOMIC_ACTIVITY_TYPE_DETAILS_RESPONSE_CHANGED:
			return {
				...state,
				fetchEconomicActivityTypeDetailsResponse: null,
				fetchEconomicActivityTypeDetailsArr: [],
			};
		/** ***************** FETCH ECONOMIC ACTIVITY TYPE DETAILS END *********************** */

		/** ***************** DELETE ECONOMIC ACTIVITY TYPE DETAILS START *********************** */
		case EconomicActivityTypeActionTypes.DELETE_ECONOMIC_ACTIVITY_TYPE_DETAILS_SUCCESS:
			return { ...state, deleteEconomicActivityTypeDetailsResponse: action.payload };

		case EconomicActivityTypeActionTypes.DELETE_ECONOMIC_ACTIVITY_TYPE_DETAILS_FAILURE:
			return { ...state, deleteEconomicActivityTypeDetailsResponse: action.payload };

		case EconomicActivityTypeActionTypes.DELETE_ECONOMIC_ACTIVITY_TYPE_DETAILS_RESPONSE_CHANGED:
			return { ...state, deleteEconomicActivityTypeDetailsResponse: null };
		/** ***************** DELETE ECONOMIC ACTIVITY TYPE DETAILS END *********************** */

		/** ***************** FETCH ALL ECONOMIC ACTIVITY TYPE  START *********************** */
		case EconomicActivityTypeActionTypes.FETCH_ALL_ECONOMIC_ACTIVITY_TYPE_SUCCESS:
			return {
				...state,
				fetchAllEconomicActivityTypesResponse: action.payload,
				fetchAllEconomicActivityTypesArr: docodeHexResponse(
					action.payload,
					'FetchAllEconomicActivityTypesKey',
				),
			};

		case EconomicActivityTypeActionTypes.FETCH_ALL_ECONOMIC_ACTIVITY_TYPE_FAILURE:
			return { ...state, fetchAllEconomicActivityTypesResponse: action.payload };

		case EconomicActivityTypeActionTypes.FETCH_ALL_ECONOMIC_ACTIVITY_TYPE_RESPONSE_CHANGED:
			return { ...state, fetchAllEconomicActivityTypesResponse: null };
		/** ***************** FETCH ALL ECONOMIC ACTIVITY TYPE  END *********************** */
		default:
			return state;
	}
};
export default economicActivityTypeReducer;
